import { render, staticRenderFns } from "./directSendPopup.vue?vue&type=template&id=b65c717a&scoped=true"
import script from "./directSendPopup.vue?vue&type=script&lang=js"
export * from "./directSendPopup.vue?vue&type=script&lang=js"
import style0 from "./directSendPopup.vue?vue&type=style&index=0&id=b65c717a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65c717a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b65c717a')) {
      api.createRecord('b65c717a', component.options)
    } else {
      api.reload('b65c717a', component.options)
    }
    module.hot.accept("./directSendPopup.vue?vue&type=template&id=b65c717a&scoped=true", function () {
      api.rerender('b65c717a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/directPurchaseSpecialPrice/directSendPopup.vue"
export default component.exports